import React from 'react';
import { Flex, Spinner } from '@radix-ui/themes';
import { NumberMetricInput } from '@/components/Form/NumberMetricInput';
import { ScaleMetricInput } from '@/components/Form/ScaleMetricInput';
import { useMetric } from '@/database/repositories/metricLogRepository';

interface SingletonMetricProps {
  metricId: string;
}

export function SingletonMetric({ metricId }: SingletonMetricProps) {
  const metric = useMetric(metricId);

  if (!metric) {
    return <Spinner />;
  }

  const mappedInput = () => {
    switch (metric.type) {
      case 'number':
        return <NumberMetricInput definition={metric} />;

      case 'scale':
        return <ScaleMetricInput definition={metric} />;

      case 'counter':
        console.log(`Rendering input for: ${metric.type}`);
        // Future implementation: Stepper (+ / - buttons) for volumetric data like water
        return null;

      default:
        console.warn(`Unsupported metric input kind: ${metric.type}`);
        return null;
    }
  };

  return (
    <Flex direction="column" gap="3">
      {mappedInput() || <p>Error rendering correct input!</p>}
    </Flex>
  );
}
